import FilePreviewDialog from './FilePreviewDialog';

export default FilePreviewDialog;
